import React from 'react';
import { CircularProgress } from '@material-ui/core';

const Progress = ({ size, color, width, height, style, className }) => (
  <div
    className={className}
    style={{
      color: color || '#adadad',
      width: width ? parseInt(width) : '100%',
      height: height ? parseInt(height) : '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...(style || {}),
    }}
  >
    <CircularProgress size={size ? size : 30} color="inherit" />
  </div>
);

export default Progress;
